<template lang="html">
  <pl-dialog
    :header="'CLOSE DATE'"
    :headerStyle="'font-weight: bold; font-size: 24px;'"
    :maxWidth="'505px'"
    @close="$emit('close')"
    class=""
  >
    <div
      class="flex flex-nowrap items-center w-100 sub-header-title"
      style="color: #000; font-size: 14px"
    >
      <span>
        This feature will automatically close the RoundTable at the date and
        time provided. It will also send an email reminder to students 24 hours
        before closing time.
      </span>
    </div>
    <div class="row no-margin center-xs courses-list" style="padding-top: 15px">
      <div
        class="row center-xs col-xs-12 col-sm-12 col-md-12 col-lg-12 close-date-toogle-style"
      >
        <span> Close Date </span>
        <toggle-button
          :sync="true"
          v-model="closeDate.enabled"
          class="ml2"
          color="#72ccd7"
        />
      </div>
      <div
        class="row center-xs col-xs-12 col-sm-12 col-md-12 col-lg-12 datepicker-style mb3"
      >
        <flat-pickr
          v-if="closeDate.enabled"
          class="roundtable-close-date-picker"
          v-model="closeDate.date"
          :config="config"
          placeholder="Select a date"
          style="color: #000"
          @on-close="changedCloseDate"
        >
        </flat-pickr>
        <div class="open-calendar" v-if="closeDate.enabled" data-toggle>
          <i class="fa fa-chevron-down"></i>
        </div>
      </div>
      <div class="mv2 row center-xs col-xs-12" v-if="closeDate.enabled">
        <pl-checkbox v-model="hard_close" class="" />
        <span class="f5 mr3"
          >Hard close?
          <i
            class="fas fa-info-circle"
            style="color: #afadad"
            v-my-tooltip.top="
              'Check this box to disable all student contributions after the close date.'
            "
          ></i>
        </span>
      </div>
    </div>
    <!-- </pl-menu> -->
    <div class="row no-margin center-xs" style="padding-top: 15px">
      <pl-button @click.native="$emit('close')" class="close-cancel-button">
        CLOSE
      </pl-button>
      <pl-button @click.native="saveCloseDate" class="pl-primary save-button">
        SAVE
      </pl-button>
    </div>
  </pl-dialog>
</template>

<script>
  import { mapGetters } from 'vuex';
  import store from 'store';
  import flatPickr from 'vue-flatpickr-component';
  export default {
    components: {
      flatPickr,
    },
    props: {
      is_live_roundtable: {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    data() {
      return {
        closeDate: {
          enabled: false,
          date: new Date(),
        },
        config: {
          altFormat: 'F j, G:i K',
          altInput: true,
          enableTime: true,
          wrap: true,
        },
        hard_close: false,
      };
    },
    computed: {
      ...mapGetters(['getCurrentRT', 'getCurrentDiscussion']),
    },
    watch: {},
    methods: {
      changedCloseDate() {},
      saveCloseDate() {
        const payload = {};
        payload.id = this.getCurrentRT.id;
        if (this.closeDate.enabled) {
          payload.is_ended = false;
          payload.end_date = new Date(this.closeDate.date);

          const timezone_end_date = payload.end_date
            ? new Date(payload.end_date)
            : new Date();

          payload.original_timezone_end_date = this.getTimezoneString(
            timezone_end_date
          );
          payload.hard_close = this.hard_close;
        } else {
          payload.hard_close = false;
          payload.end_date = null;
          payload.original_timezone_end_date = null;
        }

        payload.hard_close = this.hard_close;
        this.saveRTCloseDate(payload);
      },
      getTimezoneString(date) {
        // Get a specific point in time (here, the current date/time):
        const d = new Date();

        // Get a DateTimeFormat object for the user's current culture (via undefined)
        // Ask specifically for the long-form of the time zone name in the options
        const dtf = Intl.DateTimeFormat('en-US', { timeZoneName: 'long' });

        // Format the date to parts, and pull out the value of the time zone name
        const result = dtf
          .formatToParts(d)
          .find((part) => part.type == 'timeZoneName').value;

        return date.toString().split('(')[0] + `(${result})`;
      },
      saveRTCloseDate(payload) {
        return store.dispatch('savingRTDetails', payload).then(() => {
          this.$emit('close');
        });
      },
      setCloseDate() {
        if (this.getCurrentRT.end_date) {
          this.closeDate.enabled = true;
          this.closeDate.date = this.getCurrentRT.end_date;
        } else {
          this.closeDate.date = new Date();
        }
      },
    },
    mounted() {
      this.setCloseDate();
      this.hard_close = this.getCurrentRT.hard_close;
    },
  };
</script>

<style src="flatpickr/dist/flatpickr.css" lang="stylus">
  .tooltip
    &.customize-tooltip
      color: blue
      background-color: red
      .tooltip-inner
        background: pink
        background-color: yellow
        color: white
        padding: 24px
        max-width: 250px
        font-weight: bold
    .tooltip-arrow
      border-color: green;
</style>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  .sub-header-title{
    font-size: 12px;
    color: pl-slate;
    padding-bottom: 10px;
    padding-right: 40px;
    padding-left: 40px;
  }

  .close-date-toogle-style {
    padding-bottom: 20px;
    font-size: 18px;
  }
  .close-cancel-button {
    color: #797979 !important;
    font-weight: bold !important;
    font-size: 16px !important;
  }

  .save-button {
    font-size: 16px !important;
  }
</style>
<style lang="scss">
  .flatpickr-calendar {
    background-color: #fff;
  }

  .flatpickr-day.selected {
    background: #65c7d3;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #fff;
    border-color: #65c7d3;
  }
  .open-calendar {
    position: absolute;
    width: 280px;
    height: 30px;
    i {
      position: absolute;
      right: 5px;
      top: 5px;
    }
  }

  button,
  input {
    overflow: visible;
    border: none;
  }

  .close-date-style {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .close-date-picker input {
    margin-left: 8px;
    font-weight: bold;
    font-size: 20px;
  }

  .roundtable-close-date-picker + input {
    /* width: 185px; */
    font-weight: bold !important;
    font-size: 20px;
    text-align: center;
    &::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: black;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: black;
    }

    &::-ms-input-placeholder {
      /* Microsoft Edge */
      color: black;
    }
  }
</style>



// WEBPACK FOOTER //
// closeDateModal.vue?63ad0776